<template>
  <v-container>
    <v-card>
      <v-card-title>
        MerchantApp Başvuruları
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Ara"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn
          color="#4d48f9"
          style="text-transform: none !important; color: white;"
          @click="exportData()"
        >
          EXPORT
        </v-btn>
      </v-card-title>
      <v-row style="margin: 12px;">
        <v-col cols="12" md="3" sm="4" style="margin-top: -24px;">
          <h6 style="font-weight: 400;">Statü</h6>
          <v-select
            v-model="filters.status"
            @change="(value) => filterBy('status', value)"
            :items="statusFilterItems"
            item-text="name"
            item-value="value"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-menu
            :close-on-content-click="true"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                :label="'Başlangıç tarihi'"
                style="font-weight: bold;"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              :max="new Date().toISOString().substr(0, 10)"
              @change="filterByDateChange(date, endDate)"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-menu
            :close-on-content-click="true"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="endDate"
                :label="'Bitiş tarihi'"
                style="font-weight: bold;"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="endDate"
              :min="nowDate"
              :disabled="datePickerDisable"
              :max="
                new Date(
                  new Date().getFullYear() + 1,
                  new Date().getMonth(),
                  new Date().getDate(),
                )
                  .toISOString()
                  .substr(0, 10)
              "
              @change="filterByDateChange(date, endDate)"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-row cols="12" md="4">
          <v-icon
            style="font-size: 17px;"
            v-if="!alertPriority"
            color="#4d48f9"
            @click="alertPriority = !alertPriority"
          >
            info
          </v-icon>

          <v-alert
            v-model="alertPriority"
            border="left"
            close-text="Close Alert"
            color="#4d48f9"
            dark
            dismissible
          >
            Son Kullanma Tarihi seçilen başlangıç ve bitiş tarihi arasında olan
            başvuruları filtreler.
          </v-alert>
        </v-row>
      </v-row>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="merchantList"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
        }"
        :search="search"
        :items-per-page="filters.pageSize"
        @update:page="getPageNumber"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item.description="{ item }">
          <span style="line-break: anywhere;">{{ item.description }}</span>
        </template>
        <template v-slot:item.active="{ item }">
          <v-checkbox
            v-model="item.active"
            color="#4d48f9"
            @change="onBoardingStatusChange(item)"
          ></v-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="routeMerchantDetails(item)">
            mdi-pencil
          </v-icon>
          <!-- <v-icon small @click="onBoardingDelete(item)">mdi-delete</v-icon> -->
        </template>
      </v-data-table>

      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="filters.pageNumber"
          color="#4d48f9"
          :length="pagination.pagesLength"
          @input="setPageNumber"
        ></v-pagination>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MerchantApplications',
  data: () => ({
    search: '',
    headers: [
      { text: 'Başvuru Kodu', value: 'id', align: 'center' },
      { text: 'Mağaza Adı', value: 'companyName', align: 'start' },
      { text: 'Yetkili', value: 'authorizedPerson' },
      { text: 'Başvuru Mail Adresi', value: 'authorizedPersonMail' },
      { text: 'Telefon Numarası', value: 'phoneNumber' },
      { text: 'Başvuru Tarihi', value: 'creationDate' },
      { text: 'Statü', value: 'status' },
      { text: 'Detay', value: 'actions' },
    ],
    filters: {
      pageNumber: 1,
      pageSize: 10,
      search: '',
      startDate: '',
      endDate: '',
      status: '',
    },
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    alertPriority: false,
    statusFilterItems: [
      {
        name: 'Hepsi',
        value: '',
      },
      {
        name: 'Yeni Başvuru',
        value: 'NewApplication',
      },
      {
        name: 'Ön Başvuru Onay Bekliyor',
        value: 'PendingPreApproval',
      },
      {
        name: 'Ön Başvuru Onaylandı',
        value: 'PreApproved',
      },
      {
        name: 'Başvuru Onay Bekliyor',
        value: 'PendingApproval',
      },
      {
        name: 'Mağaza Açılışı Bekleniyor',
        value: 'AwaitingStoreOpening',
      },
      {
        name: 'Reddedildi',
        value: 'Rejected',
      },
      {
        name: 'Tamamlandı',
        value: 'Completed',
      },
    ],
  }),
  computed: mapGetters('applyMerchantForm', ['merchantList', 'loading']),
  created() {
    this.getMerchantApplications(this.filters).then((response) => {
      this.pagination.totalItems = response.totalCount
      this.pagination.pagesLength = response.totalPages
    })
  },
  methods: {
    ...mapActions('applyMerchantForm', [
      'getMerchantApplications',
      'exportMerchantApplications',
    ]),
    routeMerchantDetails(item) {
      this.$router.push(`/dashboard/apply/merchant/list/${item.id}`)
    },
    filterBy(key, value) {
      this.filters[key] = value
      this.filters.pageNumber = 1
      this.getMerchantApplications(this.filters).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    filterByDateChange(startDate, endDate) {
      if (startDate) {
        startDate = startDate.split(/[- :]/)
        this.filters.startDate =
          startDate[2] + '-' + startDate[1] + '-' + startDate[0]
      }

      if (endDate) {
        endDate = endDate.split(/[- :]/)
        this.filters.endDate = endDate[2] + '-' + endDate[1] + '-' + endDate[0]
      }

      this.filters.pageNumber = 1
      this.getMerchantApplications(this.filters).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    getItemPerPage(val) {
      this.filters.pageSize = val
      this.filters.pageNumber = 1
      this.getMerchantApplications(this.filters).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },

    getPageNumber(val) {
      this.filters.pageNumber = val
      this.getMerchantApplications(this.filters)
    },
    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return
      this.$router.push({ path: this.$route.fullPath, query: { page: val } })
    },
    exportData() {
      try {
        this.exportMerchantApplications(this.filters)
      } catch (error) {
        console.error('Export error:', error)
      }
    },
  },
  watch: {
    date: function () {
      this.nowDate = this.date
      this.datePickerDisable = false
    },
    search: function (val, oldVal) {
      if (val.length < 2 && oldVal.length < 1) return
      this.filterBy('search', val)
    },
    '$route.query.page'(val) {
      console.log(val)
      const pageNumber = val ? Number(val) : 1
      this.getPageNumber(pageNumber)
    },
  },
  mounted() {
    console.log('wtf');
    console.log(this.$router)
  },
}
</script>

<style></style>
